// extracted by mini-css-extract-plugin
export var legals = "bottomSection-module--legals--068d2";
export var mainWrapper = "bottomSection-module--mainWrapper--91bc2";